import { CustomerIoGeofence } from "@/plugins/customerio-geofence";
import { isNativeMobileApp } from "utils/platform.helpers";

/** Whether asking for the device position would show a system prompt, return it, or fail. */
export type DevicePositionPermission = "granted" | "denied" | "prompt";

/** The app's own location permission, which the web view's position requests share. */
const readNativePermission = async (): Promise<DevicePositionPermission | null> => {
  try {
    const { location } = await CustomerIoGeofence.checkLocationPermissions();
    return location === "prompt" || location === "denied" ? location : "granted";
  } catch {
    // A binary that predates the geofence plugin; the web view can still answer.
    return null;
  }
};

/** Browsers without the Permissions API can only find out by prompting, which reads as "prompt". */
const readBrowserPermission = async (): Promise<DevicePositionPermission> => {
  try {
    const { state } = await navigator.permissions.query({ name: "geolocation" });
    return state;
  } catch {
    return "prompt";
  }
};

/** Reads the permission without prompting, so a pre-ask can run before the one-shot system prompt. */
export const readLocationPermission = async (): Promise<DevicePositionPermission> =>
  (isNativeMobileApp() ? await readNativePermission() : null) ?? readBrowserPermission();
